import DTO from '@app/dao/dto';

export default class CreateTenantDTO extends DTO<CreateTenantDTO> {
  id?: number;
  type?: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  amount: number;
}
